import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PcnSyncSettingActions, { PcnSyncSettingTypes } from '../Stores/PcnSyncSetting/Actions';

const getAppStore = state => state.app;

export function* pcnSyncSettingFetchItemOptions({ search }) {
  try {
    yield put(PcnSyncSettingActions.pcnSyncSettingFetchItemOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `item/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(PcnSyncSettingActions.pcnSyncSettingFetchItemOptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PcnSyncSettingActions.pcnSyncSettingFetchItemOptionLoading(false));
  }
}

export function* pcnSyncSettingShowSetting() {
  try {
    yield put(PcnSyncSettingActions.pcnSyncSettingSaveSettingLoading(true));

    const app = yield select(getAppStore);

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `systemSetting/showSetting/PCN_SYNC_SETTING/${app.curDivisionId}`,
      app.token
    );

    if (result.isSuccess === true) {
      yield put(PcnSyncSettingActions.pcnSyncSettingSaveSettingSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PcnSyncSettingActions.pcnSyncSettingSaveSettingLoading(false));
  }
}

export function* pcnSyncSettingSaveSetting({ formikBag, settings }) {
  formikBag.setSubmitting(true);
  try {
    yield put(PcnSyncSettingActions.pcnSyncSettingSaveSettingLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      settings
    };

    const result = yield call(
      ApiService.putApi, // function
      app.apiUrl,
      `systemSetting/save/PCN_SYNC_SETTING/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(PcnSyncSettingActions.pcnSyncSettingSaveSettingSuccess(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(PcnSyncSettingActions.pcnSyncSettingSaveSettingLoading(false));
  }
}

export const saga = [
  takeLatest(
    PcnSyncSettingTypes.PCN_SYNC_SETTING_FETCH_ITEM_OPTIONS,
    pcnSyncSettingFetchItemOptions
  ),
  takeLatest(PcnSyncSettingTypes.PCN_SYNC_SETTING_SHOW_SETTING, pcnSyncSettingShowSetting),
  takeLatest(PcnSyncSettingTypes.PCN_SYNC_SETTING_SAVE_SETTING, pcnSyncSettingSaveSetting)
];
